/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.8",
    versionName: "0.2.0-nightly.2025.11.8",
    versionChannel: "nightly",
    buildDate: "2025-11-08T00:07:44.782Z",
    commitHash: "cbae3313643b18d848bad0618d896aec8f462983",
};
